import dsBridge from 'dsbridge';
import { BridgeAsync, BridgeEvents, BridgeSync } from '../Bridges/Bridges';

export type ValueType<T extends keyof K, K extends object> = T extends keyof K ? K[T] : never;
type Parameter<T> = T extends (...args: infer P) => any ? P : never;
type Return<T> = T extends (...args: any) => infer R ? R : never;
type ReturnOfPromise<T> = T extends (...args: any) => Promise<infer R> ? R : never;

export function callNative<
    TBridgeName extends keyof BridgeSync,
    TBridgeFunctions extends ValueType<TBridgeName, BridgeSync>,
    TFunctionName extends keyof TBridgeFunctions,
    TFunction extends ValueType<TFunctionName, TBridgeFunctions>
>(bridge: TBridgeName, name: TFunctionName, ...args: Parameter<TFunction>): Return<TFunction> {
    return dsBridge.call(`${bridge}.${name}`, unWrapArgs(args));
}

export async function callNativeAsync<
    TBridgeName extends keyof BridgeAsync,
    TBridgeFunctions extends ValueType<TBridgeName, BridgeAsync>,
    TFunctionName extends keyof TBridgeFunctions,
    TFunction extends ValueType<TFunctionName, TBridgeFunctions>
>(bridge: TBridgeName, name: TFunctionName, ...args: Parameter<TFunction>): Promise<ReturnOfPromise<TFunction>> {
    return new Promise((resolve) => {
        dsBridge.call(`${bridge}.${name}`, unWrapArgs(args), resolve);
    });
}

export function registerNative<
    TBridgeName extends keyof BridgeEvents,
    TBridgeFunctions extends ValueType<TBridgeName, BridgeEvents>,
    TFunctionName extends keyof TBridgeFunctions,
    TFunction extends ValueType<TFunctionName, TBridgeFunctions>
>(bridge: TBridgeName, name: TFunctionName, callback: TFunction) {
    return dsBridge.registerAsyn(`${bridge}.${name}`, callback);
}

function unWrapArgs(args: unknown[]) {
    return args.length > 1 ? args : args[0];
}
